/* Shared: the WebGL layers read their colour and blend mode out of the CSS
   palette, so a palette swap never means editing a shader again. */
(function () {
  function hex(varName, fallback) {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
      var m = /^#?([0-9a-fA-F]{6})$/.exec(v);
      if (m) {
        var n = parseInt(m[1], 16);
        return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
      }
    } catch (e) {}
    return fallback;
  }

  window.vvAccentRGB = function (fallback) {
    var f = fallback || [0.09, 0.08, 0.06];
    return hex('--vv-3d-color', hex('--vv-accent-hi', f));
  };

  /* 'add' glows on a dark ground; 'normal' prints as ink on a light one. */
  window.vvGLAdditive = function () {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--vv-3d-blend').trim();
      return v === 'add';
    } catch (e) { return false; }
  };
})();
